/** True when this tab can't be the one the user is looking at right now. */
export const tabInBackground = (): boolean =>
  document.visibilityState === "hidden" || !document.hasFocus();
